import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
const UnAuthorizedPage = ({ message, sessionTimeout, }) => {
    const navigate = useNavigate();
    const isAuthenticated = true;
    const [timeLeft, setTimeLeft] = useState(5);
    const onClickHandle = () => {
        // if (isAuthenticated) {
        //   window.history.back();
        // } else {
        navigate("/event/login");
        //}
    };
    // useEffect(() => {
    //   const timer = setInterval(() => {
    //     setTimeLeft((prevTime) => prevTime - 1);
    //   }, 1000);
    //   const timeout = setTimeout(() => {
    //     if (isAuthenticated) {
    //       window.history.back();
    //     } else {
    //       navigate("/");
    //     }
    //   }, 5000);
    //   return () => {
    //     clearInterval(timer);
    //     clearTimeout(timeout);
    //   };
    // }, [isAuthenticated, navigate]);
    return (_jsx(Grid, { container: true, children: _jsx(Grid, { size: 12, children: _jsx(Box, { display: "flex", height: "calc(100svh - 68px)", justifyContent: "center", alignItems: "center", bgcolor: "white", children: _jsxs(Box, { display: "flex", flexDirection: "column", width: "300px", justifyContent: "center", alignItems: "center", flexShrink: 0, children: [_jsx(Box, { sx: {
                                width: "300px",
                                height: "300px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                background: `url(/assets/images/image.png) no-repeat center/cover`,
                            }, children: _jsx("img", { src: sessionTimeout
                                    ? "/assets/images/timer.png"
                                    : "/assets/images/disabled.png", width: sessionTimeout ? 64 : 175, height: sessionTimeout ? 64 : 175, alt: "Disabled icon" }) }), _jsx(Box, { display: "flex", flexDirection: "column", gap: "32px", alignItems: "center", children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: 1, alignItems: "center", justifyContent: "center", children: [_jsx(Typography, { variant: "h6", textAlign: "center", children: sessionTimeout
                                            ? "Session has timed out. Redirecting in "
                                            : "Unauthorized access" }), _jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: message })] }) })] }) }) }) }));
};
export default UnAuthorizedPage;
